import React from 'react';
import { useNavigate } from 'react-router-dom';
import BackButton from '../components/BackButton';
import { useAppState } from '../state/AppState';

/**
 * ScreenX - Session ended screen.
 *
 * Informs the user that their session has ended and provides a way to return home.
 */
const ScreenX: React.FC = () => {
  const navigate = useNavigate();
  const { dispatch } = useAppState();
  
  const handleReturnHome = () => {
    // Reset the session timer
    dispatch({ type: 'SET_RESERVATION_START_TIME', payload: null });
    // Navigate to home
    navigate('/');
  };
  
  return (
    <div className="screen-bg">
      <div className="main-content-container">
        <div className="mtg-back-btn-align">
          <BackButton onClick={() => navigate(-1)} />
        </div>
        <main className="mtg-screen-main">
          <h4 style={{ width: '100%', textAlign: 'left', fontSize: '1.25rem', marginLeft: '24px' }}>Unfortunately</h4>
          <h2 style={{ width: '100%', marginTop: '0', textAlign: 'left', lineHeight: 1.2, marginLeft: '24px' }}>Your time<br />has ended.</h2>
          <div className="mtg-screen-card text-center">
            <p className="text-muted" style={{ textAlign: 'left', fontSize: '1rem', padding: '12px' }}>
              Unfortunately, the time allotted to complete the form has expired. Please click the button below to try again or give us a call at 425-640-7009 for assistance.
            </p>
            <button 
              onClick={handleReturnHome}
              className="submit-button"
            >
              Return
              <span style={{ marginTop: '-2px' }}>→</span>
            </button>
          </div>
        </main>
      </div>
    </div>
  );
};

export default ScreenX; 